import styled from 'styled-components';
import { AuthFlowColors, AuthFlowFont } from '../authFlow.constants';

export const SStepRail = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 0;

  .step-rail__node {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 600 16px/1 ${AuthFlowFont};
    border: 2px solid ${AuthFlowColors.cardBorder};
    color: ${AuthFlowColors.placeholder};
    background: ${AuthFlowColors.white};
  }
  .step-rail__node--active {
    border-color: ${AuthFlowColors.navy};
    color: ${AuthFlowColors.navy};
  }
  .step-rail__node--done {
    border-color: ${AuthFlowColors.navy};
    background: ${AuthFlowColors.navy};
    color: ${AuthFlowColors.white};
  }
  .step-rail__line {
    flex: 1 1 auto;
    height: 2px;
    background: ${AuthFlowColors.cardBorder};
  }
  .step-rail__line--done {
    background: ${AuthFlowColors.navy};
  }
`;
